import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';

import MFACard from './MFACard/MFACardContainer';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
  userId: PropTypes.string.isRequired,
  MFAEnabled: PropTypes.bool.isRequired,
};

export function UnstyledSecurityTab({ classes, userId, MFAEnabled }) {
  return (
    <div className={classes.root}>
      <MFACard MFAEnabled={MFAEnabled} userId={userId} />
    </div>
  );
}

UnstyledSecurityTab.propTypes = propTypes;

const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
});

export default withStyles(styles)(UnstyledSecurityTab);
